"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var interval_exports = {};
__export(interval_exports, {
  closedInterval: () => closedInterval,
  emptyOpenInterval: () => emptyOpenInterval,
  formatNamedInterval: () => formatNamedInterval,
  isClosedInterval: () => isClosedInterval,
  isOpenInterval: () => isOpenInterval,
  namedInterval: () => namedInterval,
  namedToOpenInterval: () => namedToOpenInterval,
  openInterval: () => openInterval,
  parseNamedInterval: () => parseNamedInterval
});
module.exports = __toCommonJS(interval_exports);
var import_guard = require("@cartographerio/guard");
var import_util = require("@cartographerio/util");
var import_date_fns = require("date-fns");
var import_lodash = require("lodash");
var import_plainDate = require("./plainDate.js");
var import_error = require("../error/index.js");
const isClosedInterval = (value) => (0, import_guard.isObject)(value) && (0, import_guard.hasKey)(value, "from", import_plainDate.isValidPlainDate) && (0, import_guard.hasKey)(value, "to", import_plainDate.isValidPlainDate);
const isOpenInterval = (value) => (0, import_guard.isObject)(value) && (0, import_guard.hasKey)(value, "from", (0, import_guard.isNullable)(import_plainDate.isValidPlainDate)) && (0, import_guard.hasKey)(value, "to", (0, import_guard.isNullable)(import_plainDate.isValidPlainDate));
const emptyOpenInterval = { from: null, to: null };
function closedInterval(from, to) {
  return { from, to };
}
function openInterval(from, to) {
  return { from, to };
}
function namedInterval(type, from, to) {
  return type === "custom" ? { type, from: from ?? null, to: to ?? null } : { type };
}
function parseNamedInterval(value, sep = "...") {
  if (value === "week" || value === "month" || value === "year") {
    return { type: value };
  } else {
    const [from, to] = value.split(sep).map((str) => (0, import_plainDate.parseAnyPlainDate)(str) ?? null);
    return from != null || to != null ? { type: "custom", from, to } : void 0;
  }
}
function formatNamedInterval(namedInterval2, sep = "...") {
  switch (namedInterval2.type) {
    case "week":
    case "month":
    case "year":
      return namedInterval2.type;
    case "custom":
      return [namedInterval2.from, namedInterval2.to].join(sep);
    default:
      return (0, import_util.checkExhausted)(namedInterval2);
  }
}
function namedToOpenInterval(namedInterval2, now = (0, import_plainDate.nowPlainDate)()) {
  const nowDate = (0, import_plainDate.plainDateToDate)(now) ?? (0, import_util.raise)((0, import_error.internalError)(`Cannot convert ${now} to a Date`));
  switch (namedInterval2.type) {
    case "week":
      return { from: (0, import_plainDate.dateToPlainDate)((0, import_date_fns.subDays)(nowDate, 7)), to: now };
    case "month":
      return { from: (0, import_plainDate.dateToPlainDate)((0, import_date_fns.subMonths)(nowDate, 1)), to: now };
    case "year":
      return { from: (0, import_plainDate.dateToPlainDate)((0, import_date_fns.subYears)(nowDate, 1)), to: now };
    case "custom":
      return (0, import_lodash.omit)(namedInterval2, "type");
    default:
      return (0, import_util.checkExhausted)(namedInterval2);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  closedInterval,
  emptyOpenInterval,
  formatNamedInterval,
  isClosedInterval,
  isOpenInterval,
  namedInterval,
  namedToOpenInterval,
  openInterval,
  parseNamedInterval
});
//# sourceMappingURL=interval.js.map
